import React from 'react';
import { Badge } from './ui/badge';
import { cn } from '@/lib/utils';

export interface ProjectPillProps {
  title: string;
  selected: boolean;
  onToggle: () => void;
  disabled?: boolean;
  className?: string;
}

export const ProjectPill: React.FC<ProjectPillProps> = ({
  title,
  selected,
  onToggle,
  disabled = false,
  className,
}) => (
  <Badge
    role="button"
    tabIndex={disabled ? -1 : 0}
    aria-pressed={selected}
    variant="outline"
    title={title}
    className={cn(
      'block max-w-[7.5rem] shrink-0 cursor-pointer select-none truncate rounded-full text-sm shadow-none sm:max-w-[10rem]',
      selected
        ? 'border-transparent bg-foreground text-background hover:bg-foreground/90'
        : 'text-foreground hover:bg-accent hover:text-accent-foreground',
      disabled && 'pointer-events-none opacity-60',
      className,
    )}
    onClick={() => {
      if (disabled) return;
      onToggle();
    }}
    onKeyDown={(event) => {
      if (disabled) return;
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        onToggle();
      }
    }}
  >
    {title}
  </Badge>
);
